// extracted by mini-css-extract-plugin
export var dark = "page-header-module--dark--724c1";
export var dotsHeaderImgWrapper = "page-header-module--dotsHeaderImgWrapper--06b4f";
export var dotsHeaderWrapper = "page-header-module--dotsHeaderWrapper--4789b";
export var hugeTitle = "page-header-module--hugeTitle--e4879";
export var image = "page-header-module--image--13f6f";
export var item = "page-header-module--item--73f85";
export var meta = "page-header-module--meta--fd443";
export var pricingPage = "page-header-module--pricingPage--a017e";
export var root = "page-header-module--root--efec5";
export var subscription = "page-header-module--subscription--78512";
export var subscriptionContainer = "page-header-module--subscriptionContainer--01543";
export var subtitle = "page-header-module--subtitle--05587";
export var title = "page-header-module--title--e200a";